import { Gallery } from 'iconsax-react';
import type { PropsWithChildren } from 'react';
import usePickMediaFile from '@/hooks/files/use-pick-media-file';
import useUserPlatform, { useUserHints } from '@/hooks/use-user-platform';
import useUploadUserAvatar from '@/hooks/users/use-upload-user-avatar';
import { FileType } from '@/utils/file-type';

interface Props {
  disable?: boolean;
  showIndicator?: boolean;
}

export function UserAvatarUploadButton({ disable, showIndicator = false, children }: PropsWithChildren<Props>) {
  const { isEmbedded, isDesktop } = useUserPlatform();
  const { ref: inputRef, promptPickMedia, pickMedia } = usePickMediaFile();
  const {
    hints: { osType },
  } = useUserHints();
  const { upload: updateHeadImg, isLoading } = useUploadUserAvatar();

  return (
    <>
      <button
        type='button'
        disabled={disable || isEmbedded}
        data-loading={isLoading}
        className='group relative'
        onClick={() =>
          isDesktop || osType === 'desktop' ? pickMedia({ type: 'album', accept: FileType.Image }) : promptPickMedia()
        }>
        <span className='group-data-[loading=true]:blur'>{children}</span>

        <span className='loading loading-spinner loading-sm absolute left-1/2 top-1/2 z-10 hidden -translate-x-1/2 -translate-y-1/2 text-secondary group-data-[loading=true]:inline' />

        {showIndicator && (
          <span className='absolute right-0 bottom-0 bg-neutral-0 p-1.5 rounded-full shadow'>
            <Gallery
              variant='Bold'
              className='size-4 text-body'
            />
          </span>
        )}
      </button>

      <input
        type='file'
        accept='image/*'
        className='sr-only'
        ref={inputRef}
        value=''
        onChange={(e) => {
          if (e.target.files?.[0]) {
            updateHeadImg(e.target.files[0]).catch(console.error);
          }
        }}
      />
    </>
  );
}
